import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { KpiResult, formatKpiValue } from '@/lib/kpis';

/** A single dashboard KPI tile: name, current value, target delta, mini trend. */
export function KpiTile({ kpi }: { kpi: KpiResult }) {
  const val = kpi.current;
  const display = formatKpiValue(val, kpi.format, kpi.reportingCurrency);
  const vsTarget = val !== null && kpi.target !== null ? val - kpi.target : null;
  const sparkVals = kpi.points.map((p) => p.value).filter((v): v is number => v !== null);
  const trend = sparkVals.length >= 2 ? sparkVals[sparkVals.length - 1] - sparkVals[0] : 0;

  return (
    <div className="rounded-md border border-border bg-white p-4">
      <p className="text-[12px] font-semibold text-ink-600 truncate">{kpi.name}</p>
      <div className="mt-1 flex items-baseline gap-2">
        <span className="num text-2xl font-semibold text-ink-900 tabular-nums">{display}</span>
        {trend !== 0 && (
          trend > 0 ? <TrendingUp className="h-4 w-4 text-emerald-600" /> : <TrendingDown className="h-4 w-4 text-warn-500" />
        )}
        {trend === 0 && val !== null && <Minus className="h-4 w-4 text-ink-300" />}
      </div>
      <div className="mt-1.5 flex items-center gap-2 text-[11px]">
        {kpi.target !== null && (
          <span className="num text-muted-foreground">target {formatKpiValue(kpi.target, kpi.format, kpi.reportingCurrency)}</span>
        )}
        {vsTarget !== null && (
          <span className={`num font-semibold ${vsTarget >= 0 ? 'text-emerald-700' : 'text-warn-600'}`}>
            {vsTarget >= 0 ? '+' : ''}{formatKpiValue(vsTarget, kpi.format, kpi.reportingCurrency)}
          </span>
        )}
        <span className="num text-ink-400 ml-auto">{kpi.scenario}</span>
      </div>
    </div>
  );
}
